export default __webpack_public_path__ + "static/Mixed-Reality-cb5f84210653ee4ab1b8c2205a434a00.webp";